export const loginConstants = {
  LOGIN_PROCESSING: "LOGIN_PROCESSING",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  USER_LOGGED_IN: "USER_LOGGED_IN"
};
